export const getArrayValues = (e) => {
    let input = e.target.nextElementSibling.value;
    let newValues = [];
    let inputs = document.querySelectorAll(".arrayStringValue input");
    for (const item of inputs) {
        if (input != item.value) {
            newValues.push(item.value);
        }
    }
    return newValues;
}

export const setArrayValues = (e, key) => {
    let newValues = [];
    let inputs = document.querySelectorAll(".arrayStringValue input");
    for (const item of inputs) {
        newValues.push(item.value);
    }
    if (key == 'TASK_STATUS') {
        newValues.splice((newValues.length - 1), 0, "");
    } else {
        newValues.push("");
    }

    return newValues;
}
